(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dunisca-pack"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.duniscaPackReady) return;
    window.duniscaPackReady = true;

    var estado = { pack: 1, tab: 1, c1: null, c2: null };
    var saltar = false;

    function pack() {
      return document.querySelector('dunisca-pack');
    }

    function caja() {
      var el = pack();
      return (el && (el.closest('.product-details') || el.closest('.product-information'))) || document;
    }

    function formulario() {
      return caja().querySelector('form[data-type="add-to-cart-form"]');
    }

    function inputCantidad() {
      var f = formulario();
      return f ? f.querySelector('input[name="quantity"]') : null;
    }

    function actual() {
      var f = formulario();
      var i = f ? f.querySelector('input[name="id"]') : null;
      return i ? i.value : null;
    }

    function picker() {
      return caja().querySelector('variant-picker');
    }

    function radioDe(id) {
      var p = picker();
      return p ? p.querySelector('input[type="radio"][data-variant-id="' + id + '"]') : null;
    }

    function nombreDe(id) {
      var r = radioDe(id);
      return r ? r.value : '';
    }

    function irA(id) {
      if (!id || id === actual()) return;
      var r = radioDe(id);
      if (r && !r.checked) r.click();
    }

    function marcar(radios, igual) {
      radios.forEach(function (r) {
        var activo = igual(r);
        if (r.checked === activo && r.dataset.currentChecked === String(activo)) return;
        r.dataset.previousChecked = r.dataset.currentChecked === 'true' && !activo ? 'true' : 'false';
        r.dataset.currentChecked = activo ? 'true' : 'false';
        r.checked = activo;
      });
    }

    function pintar() {
      var el = pack();
      if (!el) return;

      var raiz = document.documentElement;
      var valorPack = String(estado.pack || 0);
      if (raiz.dataset.duniscaPack !== valorPack) raiz.dataset.duniscaPack = valorPack;

      marcar(el.querySelectorAll('input[data-pack]'), function (r) {
        return r.value === String(estado.pack);
      });

      marcar(document.querySelectorAll('dunisca-colores input[data-tab]'), function (r) {
        return r.value === String(estado.tab);
      });

      var ahora = actual();
      document.querySelectorAll('[data-nombre-tab]').forEach(function (n) {
        var id = n.dataset.nombreTab === '2' ? estado.c2 || ahora : estado.c1 || ahora;
        var texto = nombreDe(id);
        if (texto && n.textContent !== texto) n.textContent = texto;
      });

      var input = inputCantidad();
      if (input && (estado.pack === 1 || estado.pack === 2) && input.value !== String(estado.pack)) {
        input.value = estado.pack;
      }
    }

    function leerCantidad() {
      var input = inputCantidad();
      if (!input) return;
      var n = parseInt(input.value, 10) || 1;
      var antes = estado.pack;
      estado.pack = n === 1 ? 1 : n === 2 ? 2 : 0;
      if (estado.pack === 2 && antes !== 2) empezarDos();
      if (estado.pack !== 2 && antes === 2) terminarDos();
      pintar();
    }

    function empezarDos() {
      var ahora = actual();
      estado.tab = 1;
      estado.c1 = ahora;
      if (!estado.c2) estado.c2 = ahora;
    }

    function terminarDos() {
      var volver = estado.tab === 2 ? estado.c1 : null;
      estado.tab = 1;
      if (volver) irA(volver);
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!(t instanceof HTMLInputElement)) return;

      if (t.dataset.tab) {
        estado.tab = Number(t.dataset.tab);
        irA(estado['c' + estado.tab]);
        pintar();
        return;
      }

      if (t.dataset.pack) {
        var antes = estado.pack;
        estado.pack = Number(t.dataset.pack);
        if (estado.pack === 2 && antes !== 2) empezarDos();
        if (estado.pack !== 2 && antes === 2) terminarDos();
        pintar();
        return;
      }

      if (t.type === 'radio' && t.dataset.variantId && t.closest('variant-picker')) {
        if (estado.pack === 2) {
          estado['c' + estado.tab] = t.dataset.variantId;
        } else {
          estado.c1 = t.dataset.variantId;
        }
        pintar();
        return;
      }

      if (t.name === 'quantity' && t.closest('form[data-type="add-to-cart-form"]')) {
        leerCantidad();
      }
    });

    document.addEventListener('click', function (e) {
      var t = e.target instanceof Element ? e.target : null;
      if (t && t.closest('.quantity-minus, .quantity-plus')) {
        setTimeout(leerCantidad, 50);
      } else {
        setTimeout(pintar, 400);
      }
    });

    document.addEventListener('focusout', function (e) {
      var t = e.target;
      if (t instanceof HTMLInputElement && t.name === 'quantity') setTimeout(leerCantidad, 50);
    });

    window.addEventListener(
      'submit',
      function (e) {
        var f = e.target;
        if (saltar || !(f instanceof HTMLFormElement) || f !== formulario()) return;
        if (estado.pack !== 2) return;

        var ahora = actual();
        var otro = estado.tab === 2 ? estado.c1 : estado.c2;
        if (!ahora || !otro || otro === ahora) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(otro), quantity: 1 }] }),
        })
          .catch(function () {})
          .then(function () {
            var input = inputCantidad();
            if (input) input.value = 1;
            saltar = true;
            f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            saltar = false;
            setTimeout(function () {
              var i = inputCantidad();
              if (i) i.value = 2;
            }, 300);
          });
      },
      true
    );

    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        pintar();
      });
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });

    if (!customElements.get('dunisca-pack')) {
      customElements.define(
        'dunisca-pack',
        class extends HTMLElement {
          connectedCallback() {
            setTimeout(pintar, 0);
          }
        }
      );
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
